module.exports = __webpack_public_path__ + "img/wa.c856a20f.png";